import * as React from 'react';
import { ServiceSummary } from '../../../features/service-summary';
const BusinessLounge = ({ onServiceDelete }) => {
    return (React.createElement(ServiceSummary, { serviceType: "BusinessLounge", onDelete: onServiceDelete }, content => React.createElement(React.Fragment, null, content)));
};
export default BusinessLounge;
